import React from 'react'
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Link,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
} from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import messages from '../../messages'
import { makeStyles, Theme } from '@material-ui/core/styles'
import ClearIcon from '@material-ui/icons/Clear'
import { BiTubeProduct } from '../../products/BiTube/enum'
import { TubeProduct } from '../../utils/enum'

const useStyles = makeStyles((theme: Theme) => {
  return {
    dialog: {
      overflow: 'hidden',
    },
    clearButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
    },
    rootRow: {
      background: '#F2F3F4',
      fontWeight: theme.typography.fontWeightMedium,
      borderBottom: 0,
      padding: theme.spacing(1),
    },
    tableBody: {
      padding: theme.spacing(1),
    },
    title: {
      backgroundColor: '#F2F3F4',
      fontSize: theme.typography.pxToRem(16),
      padding: theme.spacing(2),
      fontWeight: theme.typography.fontWeightMedium,
    },
    table: {
      minWidth: theme.spacing(200),
      marginBottom: theme.spacing(2),
    },
    popupLabel: {
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(0),
    },
    resetBorderBottom: {
      borderBottom: '0 none',
      padding: theme.spacing(0),
      paddingTop: theme.spacing(1),
    },
  }
})

interface ODYield {
  dialogOpen: boolean
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>
  productName: any
  isValid: boolean
}

const ODYieldPopup: React.FC<ODYield> = (props) => {
  const classes = useStyles()
  const { dialogOpen, setDialogOpen, productName, isValid } = props
  const handleClose = () => {
    setDialogOpen(false)
  }
  const handleClickOpen = () => {
    setDialogOpen(true)
  }

  const viewDialog = () => {
    return (
      <Dialog
        onClose={handleClose}
        open={dialogOpen}
        maxWidth="md"
        classes={{ paperScrollPaper: classes.dialog }}
      >
        <DialogTitle className={classes.title}>
          <FormattedMessage {...messages.CONF_PROBE_OD_YIELD_POPUP_LABEL} />
        </DialogTitle>
        <IconButton
          className={classes.clearButton}
          color="primary"
          onClick={handleClose}
        >
          <ClearIcon />
        </IconButton>
        <DialogContent>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell align="center" className={classes.rootRow}>
                  <FormattedMessage
                    {...messages.CONF_PROBE_OD_YIELD_POPUP_FIRST_COLUMN}
                  />
                </TableCell>
                <TableCell align="center" className={classes.rootRow}>
                  <FormattedMessage
                    {...messages.CONF_PROBE_OD_YIELD_POPUP_SECOND_COLUMN}
                  />
                </TableCell>
                <TableCell align="center" className={classes.rootRow}>
                  <FormattedMessage
                    {...messages.CONF_PROBE_OD_YIELD_POPUP_THIRD_COLUMN}
                  />
                </TableCell>
                <TableCell align="center" className={classes.rootRow}>
                  <FormattedMessage
                    {...messages.CONF_PROBE_OD_YIELD_POPUP_FOURTH_COLUMN}
                  />
                </TableCell>
              </TableRow>
            </TableHead>
            {productName !== BiTubeProduct.LightCycler ? (
              <TableBody>
                <TableRow>
                  <TableCell align="center" className={classes.tableBody}>
                    1
                  </TableCell>
                  {productName !== TubeProduct.Beacon ? (
                    <TableCell align="center" className={classes.tableBody}>
                      4
                    </TableCell>
                  ) : (
                    <TableCell align="center" className={classes.tableBody}>
                      3
                    </TableCell>
                  )}
                  <TableCell align="center" className={classes.tableBody}>
                    32
                  </TableCell>
                  {productName !== TubeProduct.Beacon ? (
                    <TableCell align="center" className={classes.tableBody}>
                      800
                    </TableCell>
                  ) : (
                    <TableCell align="center" className={classes.tableBody}>
                      600
                    </TableCell>
                  )}
                </TableRow>
                <TableRow>
                  <TableCell align="center" className={classes.tableBody}>
                    3
                  </TableCell>
                  {productName !== TubeProduct.Beacon ? (
                    <TableCell align="center" className={classes.tableBody}>
                      12
                    </TableCell>
                  ) : (
                    <TableCell align="center" className={classes.tableBody}>
                      9
                    </TableCell>
                  )}
                  <TableCell align="center" className={classes.tableBody}>
                    96
                  </TableCell>
                  {productName !== TubeProduct.Beacon ? (
                    <TableCell align="center" className={classes.tableBody}>
                      2,400
                    </TableCell>
                  ) : (
                    <TableCell align="center" className={classes.tableBody}>
                      1,800
                    </TableCell>
                  )}
                </TableRow>

                <TableRow>
                  <TableCell align="center" className={classes.tableBody}>
                    5
                  </TableCell>
                  {productName !== TubeProduct.Beacon ? (
                    <TableCell align="center" className={classes.tableBody}>
                      20
                    </TableCell>
                  ) : (
                    <TableCell align="center" className={classes.tableBody}>
                      15
                    </TableCell>
                  )}
                  <TableCell align="center" className={classes.tableBody}>
                    160
                  </TableCell>
                  {productName !== TubeProduct.Beacon ? (
                    <TableCell align="center" className={classes.tableBody}>
                      4,000
                    </TableCell>
                  ) : (
                    <TableCell align="center" className={classes.tableBody}>
                      3,000
                    </TableCell>
                  )}
                </TableRow>
                <TableRow>
                  <TableCell align="center" className={classes.tableBody}>
                    10
                  </TableCell>
                  {productName !== TubeProduct.Beacon ? (
                    <TableCell align="center" className={classes.tableBody}>
                      40
                    </TableCell>
                  ) : (
                    <TableCell align="center" className={classes.tableBody}>
                      30
                    </TableCell>
                  )}
                  <TableCell align="center" className={classes.tableBody}>
                    320
                  </TableCell>
                  {productName !== TubeProduct.Beacon ? (
                    <TableCell align="center" className={classes.tableBody}>
                      8,000
                    </TableCell>
                  ) : (
                    <TableCell align="center" className={classes.tableBody}>
                      6,000
                    </TableCell>
                  )}
                </TableRow>

                <TableRow>
                  <TableCell className={classes.resetBorderBottom} colSpan={5}>
                    {productName !== TubeProduct.Beacon ? (
                      <div>
                        <FormattedMessage
                          {...messages.CONF_PROBE_OD_YIELD_POPUP_NOTICE}
                        />
                      </div>
                    ) : (
                      <div>
                        <FormattedMessage
                          {...messages._PC_YIELD_RECOMMEND_NOTE_BEACON}
                        />
                      </div>
                    )}
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <TableBody>
                <TableRow>
                  <TableCell align="center" className={classes.tableBody}>
                    0.1
                  </TableCell>
                  <TableCell align="center" className={classes.tableBody}>
                    0.4
                  </TableCell>
                  <TableCell align="center" className={classes.tableBody}>
                    3.2
                  </TableCell>
                  <TableCell align="center" className={classes.tableBody}>
                    80
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="center" className={classes.tableBody}>
                    0.25
                  </TableCell>
                  <TableCell align="center" className={classes.tableBody}>
                    1
                  </TableCell>
                  <TableCell align="center" className={classes.tableBody}>
                    8
                  </TableCell>
                  <TableCell align="center" className={classes.tableBody}>
                    200
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="center" className={classes.tableBody}>
                    1.5
                  </TableCell>
                  <TableCell align="center" className={classes.tableBody}>
                    6
                  </TableCell>
                  <TableCell align="center" className={classes.tableBody}>
                    48
                  </TableCell>
                  <TableCell align="center" className={classes.tableBody}>
                    1,200
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="center" className={classes.tableBody}>
                    15
                  </TableCell>
                  <TableCell align="center" className={classes.tableBody}>
                    60
                  </TableCell>
                  <TableCell align="center" className={classes.tableBody}>
                    480
                  </TableCell>
                  <TableCell align="center" className={classes.tableBody}>
                    12,000
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.resetBorderBottom} colSpan={5}>
                    <div>
                      <FormattedMessage
                        {...messages.CONF_PROBE_OD_YIELD_POPUP_NOTICE}
                      />
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </DialogContent>
      </Dialog>
    )
  }
  return (
    <div>
      <Link
        component="button"
        underline={isValid ? 'none' : 'hover'}
        disabled={isValid}
        onClick={handleClickOpen}
      >
        <i>
          <FormattedMessage {...messages.CONF_PROBE_OD_YIELD_POPUP_LABEL} />
        </i>
      </Link>
      {viewDialog()}
    </div>
  )
}

export default ODYieldPopup
